<app-btn-fab (click)="onChangeStatus()" icon="fas fa-shuffle" textColor="text-red-500 disabled:text-gray-200"
    tooltip="Change Status" [position]="position"></app-btn-fab>